import React from 'react';
import s from '../OnboardingPage.module.scss';

export function FourthCustomizationStep({ classNames, getStartedPdf }) {
    return (<><h2 style={{
        marginBottom: '2rem'
    }} className={classNames([s.stepHeader, s.fontWeight600, s.blackFont])}>
        Congrats! You're all set!
    </h2>
        <div style={{
            fontSize: '1.35rem'
        }}>
            <p>Our team will contact you shortly to  activate your community.</p>
            <p>In the meantime, to learn more about Squadded, check our guide:</p>
            <a href={getStartedPdf} download>How to get started with Squadded?</a>
            <div style={{
                marginTop: '1rem'
            }}>Talk soon,</div>
            <div style={{
                fontWeight: 'bold'
            }}>Squadded Team</div>
        </div></>);
}